/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './InsuranceInformation.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

const PreviousInsuranceInformation = ({ t, setInsuranceInfo, activeTab, setActiveTab, useExistingInsurance, permitsWithInsurance }) => {
  const { insuranceCompany } = useSelector((state) => state.app)

  // const { permits } = useSelector((state) => state.app)

  // const getPermitData = (insuranceCompany, policyNumber) => {
  //   try {
  //     let permitData = permits.filter((permitInfo) => permitInfo.insuranceCompany === insuranceCompany && permitInfo.policyNumber === policyNumber)
  //     if (permitData.length > 0) {
  //       return permitData[0]
  //     }
  //     return ''
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }

  // const handleCheckbox = (e) => {
  //   try {
  //     if (e.currentTarget.checked) {
  //       let [insuranceCompany, policyNumber] = e.currentTarget.id.split('-')
  //       let insuranceInfo = getPermitData(insuranceCompany, policyNumber)
  //       setInsuranceInfo({
  //         insuranceCompany: insuranceInfo.insuranceCompany,
  //         policyNumber: insuranceInfo.policyNumber,
  //         effectiveDate: insuranceInfo.effectiveDate,
  //         expiryDate: insuranceInfo.expiryDate
  //       })
  //     }
  //     else {
  //       setInsuranceInfo({
  //         insuranceCompany: '',
  //         policyNumber: '',
  //         effectiveDate: '',
  //         expiryDate: ''
  //       })
  //     }
  //   }
  //   catch (err) {
  //     console.log(err)
  //   }
  // }

  const getUniqueInsurances = () => {
    if (permitsWithInsurance.length === 0) {
      return []
    }
    const lastPermit = permitsWithInsurance[permitsWithInsurance.length - 1]
    // permits.map(each => {
    //   if (insurances.length > 0) {
    //     if (insurances.some(el =>
    //       (el.insuranceCompany !== each.insuranceCompany) || (el.policyNumber !== each.policyNumber)
    //     )) {
    //       insurances.push({
    //         insuranceCompany: each.insuranceCompany, policyNumber: each.policyNumber, effectiveDate: each.effectiveDate, expiryDate: each.expiryDate
    //       })
    //     }
    //   }
    //   else {
    //     insurances.push({
    //       insuranceCompany: each.insuranceCompany, policyNumber: each.policyNumber, effectiveDate: each.effectiveDate, expiryDate: each.expiryDate
    //     })
    //   }
    // })
    setInsuranceInfo(lastPermit)
    return [lastPermit]
  }

  const handleActiveTab = (e) => {
    if (activeTab === t('insurance_retrieved_display.add_insurance_information')) {
      setActiveTab(e)
    } else if (Number.isInteger(e) && e !== activeTab) {
      setActiveTab(e)
    } else {
      setActiveTab(t('insurance_retrieved_display.add_insurance_information'))
    }
  }

  const formatDate = (dateString) => {
    return moment(dateString, 'YYYY-MM-DD').format('DD-MMM-YYYY')
  }

  return (
    <Fragment>
      {permitsWithInsurance &&
        permitsWithInsurance
          .filter((eachInsurance, index, self) => index === self.findIndex((t) => t.insuranceCompany === eachInsurance.insuranceCompany))
          .filter((eachInsurance) =>
            useExistingInsurance === false
              ? insuranceCompany !== eachInsurance.insuranceCompany
              : eachInsurance.sinsurancePosition !== 'existing'
          )
          .map((eachInsurance, i) => {
            return (
              <div style={{ marginBottom: '25px' }}>
                <div className="row row-odd">
                  <div className="col-xs-6">
                    <strong>{t('insurance_information.insurance_company')}</strong>
                  </div>
                  <div className="col-xs-6">{eachInsurance.insuranceCompany.toUpperCase()}</div>
                </div>
                <div className="row row-even">
                  <div className="col-xs-6">
                    <strong>{t('insurance_information.policy_number')}</strong>
                  </div>
                  <div className="col-xs-6">{eachInsurance.policyNumber}</div>
                </div>
                <div className="row row-odd">
                  <div className="col-xs-6">
                    <strong>{t('insurance_information.effective_date')}</strong>
                  </div>
                  <div className="col-xs-6">{formatDate(eachInsurance.effectiveDate)}</div>
                </div>
                <div className="row row-even">
                  <div className="col-xs-6">
                    <strong>{t('insurance_information.expiry_date')}</strong>
                  </div>
                  <div className="col-xs-6">{formatDate(eachInsurance.expiryDate)}</div>
                </div>
              </div>
            )
          })}
    </Fragment>
  )
}

export default withTranslation('common')(PreviousInsuranceInformation)
